/******/ (() => { // webpackBootstrap
class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = -1;
    this._onClick = this._onClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
  }

  connectedCallback() {
    this.nav = this.querySelector('.featured-collections-tabs__nav');
    this.tabs = this.nav ? Array.from(this.nav.querySelectorAll('.featured-collections-tabs__tab')) : [];
    this.panels = Array.from(this.querySelectorAll(':scope > .featured-collections-tabs__panels > .featured-collections-tabs__panel'));

    if (!this.tabs.length || !this.panels.length || !this.nav) return;

    this.nav.addEventListener('click', this._onClick);
    this.nav.addEventListener('keydown', this._onKeydown);

    let initial = parseInt(this.dataset.defaultTab || '0', 10);
    if (!Number.isFinite(initial) || initial < 0 || initial >= this.tabs.length) initial = 0;

    let preActive = -1;
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].classList.contains('is-active')) { preActive = i; break; }
    }
    this.activeIndex = preActive >= 0 ? preActive : initial;

    if (preActive < 0) this.activate(initial, false);
  }

  disconnectedCallback() {
    if (this.nav) {
      this.nav.removeEventListener('click', this._onClick);
      this.nav.removeEventListener('keydown', this._onKeydown);
    }
  }

  _onClick(event) {
    const tab = event.target.closest('.featured-collections-tabs__tab');
    if (!tab || !this.nav.contains(tab)) return;
    const index = this.tabs.indexOf(tab);
    if (index < 0 || index === this.activeIndex) return;
    this.activate(index, true);
  }

  _onKeydown(event) {
    const tab = event.target.closest('.featured-collections-tabs__tab');
    if (!tab || !this.nav.contains(tab)) return;
    const current = this.tabs.indexOf(tab);
    if (current < 0) return;

    const last = this.tabs.length - 1;
    let next;
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = current === last ? 0 : current + 1; break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = current === 0 ? last : current - 1; break;
      case 'Home':
        next = 0; break;
      case 'End':
        next = last; break;
      default:
        return;
    }

    event.preventDefault();
    if (next !== this.activeIndex) this.activate(next, true);
    else this.tabs[next].focus();
  }

  activate(index, focus) {
    if (index === this.activeIndex) return;

    const prev = this.activeIndex;
    this.activeIndex = index;

    if (prev >= 0) {
      const prevTab = this.tabs[prev];
      const prevPanel = this.panels[prev];
      if (prevTab) {
        prevTab.classList.remove('is-active');
        prevTab.setAttribute('aria-selected', 'false');
        prevTab.setAttribute('tabindex', '-1');
      }
      if (prevPanel) {
        prevPanel.classList.remove('is-active');
        prevPanel.setAttribute('hidden', '');
      }
    }

    const nextTab = this.tabs[index];
    const nextPanel = this.panels[index];
    if (nextTab) {
      nextTab.classList.add('is-active');
      nextTab.setAttribute('aria-selected', 'true');
      nextTab.setAttribute('tabindex', '0');
      if (focus) nextTab.focus();
    }
    if (nextPanel) {
      nextPanel.removeAttribute('hidden');
      nextPanel.classList.add('is-active');
    }

    this.dispatchEvent(new CustomEvent('collection-tabs:change', { bubbles: true, detail: { index } }));
  }
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
}

/******/ })()
;
